module.exports = __webpack_public_path__ + "img/1.0351b4f2.png";